module.exports = __webpack_public_path__ + "img/company.d1bd04d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/company.png
// module id = 858
// module chunks = 1